import { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const OutreachFilterContext = createContext(() => {});

const OutreachFilterProvider = ({ children }) => {
  const [createdDateRange, setCreatedDateRange] = useState({ from: null, to: null });
  const [scheduledDateRange, setScheduledDateRange] = useState({ from: null, to: null });
  const [sentDateRange, setSentDateRange] = useState({ from: null, to: null });
  const [replyDateRange, setReplyDateRange] = useState({ from: null, to: null });
  const [selectedEmailAddresses, setSelectedEmailAddresses] = useState([]);
  const [selectedNames, setSelectedNames] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [replyStatus, setReplyStatus] = useState('');
  const [filterType, setFilterType] = useState('');

  return (
    <OutreachFilterContext.Provider
      value={{
        selectedEmailAddresses,
        setSelectedEmailAddresses,
        createdDateRange,
        setCreatedDateRange,
        scheduledDateRange,
        setScheduledDateRange,
        sentDateRange,
        setSentDateRange,
        replyDateRange,
        setReplyDateRange,
        selectedFilters,
        setSelectedFilters,
        filterOptions,
        setFilterOptions,
        selectedNames,
        setSelectedNames,
        replyStatus,
        setReplyStatus,
        filterType,
        setFilterType,
      }}
    >
      {children}
    </OutreachFilterContext.Provider>
  );
};

const useOutreachFilterProvider = () => {
  const context = useContext(OutreachFilterContext);
  if (!context) {
    throw new Error('useOutreachFilterProvider must be used within a OutreachFilterProvider');
  }
  return context;
};

OutreachFilterProvider.propTypes = {
  children: PropTypes.any,
};

export { OutreachFilterProvider, OutreachFilterContext, useOutreachFilterProvider };
